import { render, staticRenderFns } from "./RegisterReleases.vue?vue&type=template&id=59e3639c&scoped=true&"
import script from "./RegisterReleases.vue?vue&type=script&lang=js&"
export * from "./RegisterReleases.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReleases.vue?vue&type=style&index=0&id=59e3639c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e3639c",
  null
  
)

export default component.exports